import moment from 'moment';
import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* therapistDialogAssignTask(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.therapistDialogAssignTask,
      action.payload
    );
    if (response?.status === 200) {
      yield put({
        type: TherapistAction.THERAPIST_DIALOG_ASSIGN_TASK_SUCCESS,
        payload: response.data,
      });
      if (response.data?.data.length === 0) {
        yield put({
          type: TherapistAction.GET_ALL_THERAPIST_TASK_REQUEST,
          payload: {
            data: {
              providerId: action.payload.providerId,
              localDate: action.payload.date,
              type: '',
              active: true,
              discipline: action.payload.discipline,
              skill: '',
              isV2: action.payload?.isV2,
            },
            pageNo: 0,
          },
        });
        yield put({
          type: TherapistAction.DISABLE_AUTO_MATCH_REQUEST,
          payload: {
            providerId: action.payload.providerId,
            discipline: action.payload.discipline,
            currentDate: action.payload.currentDate || action.payload.date,
          },
        });
        yield put({
          type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST,
          payload: {
            providerId: action.payload.providerId,
            localDate: action.payload.date,
            data: { isV2: action.payload?.isV2 },
          },
        });
        yield put({
          type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST,
          payload: {
            pageNo: 0,
            data: {
              providerId: action.payload.providerId,
              localDate: action.payload.date
                ? moment(action.payload.date, 'DD-MM-YYYY').format('YYYY-MM-DD')
                : '',
              discipline: action.payload.discipline,
              sortBy: action.payload.sortBy,
              searchData: action.payload?.searchData,
              filterByUuid: action.payload?.filterByUuid,
            },
          },
        });
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: TherapistAction.THERAPIST_DIALOG_ASSIGN_TASK_FAILURE, payload: error });
  }
}

function* therapistDialogAssignTaskSaga() {
  yield takeEvery(TherapistAction.THERAPIST_DIALOG_ASSIGN_TASK_REQUEST, therapistDialogAssignTask);
}

export default therapistDialogAssignTaskSaga;
